import { render, staticRenderFns } from "./StoryPreview.vue?vue&type=template&id=583e290f&scoped=true&"
import script from "./StoryPreview.vue?vue&type=script&lang=ts&"
export * from "./StoryPreview.vue?vue&type=script&lang=ts&"
import style0 from "./StoryPreview.vue?vue&type=style&index=0&id=583e290f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583e290f",
  null
  
)

export default component.exports